module.exports = __webpack_public_path__ + "assets/media/purple-arrow.86228b65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingPlaybookWoohooStep/BotWoohoo/purple-arrow.svg
// module id = 3131
// module chunks = 0